<template>
    <md-field>
        <label :for="id">{{$t(label)}}</label>
        <md-select
                class="select-field"
                :name="id"
                :id="id"
                :autocomplete="id"
                v-model="model"
                ref="native"
                :multiple="multiple"
                @input="$emit('input', $refs.native.model)"
                :disabled="disabled"
        >
            <md-option :value="option.value" :key="index" v-for="(option, index) in options">
                {{ $t(option.label) || option.value }}
                <md-tooltip v-if="option.hint" md-direction="left">{{ $t(option.hint) }}</md-tooltip>
            </md-option>
        </md-select>
        <span class="md-helper-text" v-if="helperText">{{$t(helperText)}}</span>
        <span class="md-error">{{$t(description || 'Validation.genericError')}}</span>
    </md-field>
</template>

<script>
    export default {
      data() {
        return {
          model: this.value,
        }
      },
      watch: {
        value(value) {
          this.model = value;
        }
      },
      props: {
        id: String,
        label: {},
        disabled: Boolean,
        value: {},
        options: Array,
        description: {},
        helperText: {},
        multiple: Boolean
      },
    }
</script>
